/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PatientClinTrakDataService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param patientId
     * @returns boolean
     * @throws ApiError
     */
    public patientClinTrakDataExistsInClinTrak(
        patientId: number,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/patients/exists/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
}
